import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TankService } from 'src/app/services/tank.service';
import { UserService } from 'src/app/services/user.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { VoucherService } from 'src/app/services/voucher.service';
import { Tank } from 'src/app/shared/models/Tank';
import { Voucher } from 'src/app/shared/models/Voucher';
import swal from 'sweetalert';


@Component({
  selector: 'app-list-voucher-page',
  templateUrl: './list-voucher-page.component.html',
  styleUrls: ['./list-voucher-page.component.css']
})
export class ListVoucherPageComponent implements OnInit {

  vouchers: Voucher[] = [];
  vehicles = [];
  operators = [];
  originalVouchers: Voucher[] = [];
  currentTank: Tank;
  filter = null;

  constructor(private voucherService: VoucherService, private tankService: TankService,
    private userService: UserService,
    private vehicleService: VehicleService,
    private router: Router,
  ) {

  }

  ngOnInit() {

    this.tankService.getCurrentTank().subscribe((tank) => {
      this.currentTank = tank;


      /* if (this.userService.currentUser.role == "operador") {
         this.router.navigate(['/login']);
       } else {
         this.listVouchers();
       }*/
      // Después de obtener el tanque, obtenemos la lista de cargos.
      this.listVouchers();
    });
  }

  listVouchers() {
    this.voucherService.getVoucherByTankWithVehicle(this.currentTank.id).subscribe(
      (data) => {
        // console.log("this.vouchers", this.vouchers);
        this.vouchers = data.vouchers;
        this.vehicles = data.vehicles;
        this.operators = data.operators;
        //console.log('operadores', this.operators);
        //console.log('vehicles', this.vehicles);
        // console.log(data)
        this.originalVouchers = data.vouchers;
      }, (error) => {
        console.log(error);
      }
    );
  }



  deleteVoucher(id: any) {
    if (this.voucherService.deleteVoucher(id).subscribe(data => {
      this.listVouchers();
    }, error => {
      console.log(error);
    })) {
      return;
    }
  }


  confirmAction() {
    // Muestra la alerta de confirmación
    const userConfirmed = window.confirm('¿Estás seguro de realizar esta acción?');

    // Verifica la respuesta del usuario
    if (userConfirmed) {
      // El usuario hizo clic en "Aceptar", realiza la acción deseada aquí
      console.log('Acción realizada');
    } else {
      // El usuario hizo clic en "Cancelar", puedes manejarlo si es necesario
      console.log('Acción cancelada');
    }
  }



  cancelVoucher(id: number) {

    //const userConfirmed = window.confirm('Desea cambiar el estado del voucher a CANCELADO? ');
    swal({
      title: "Estas Seguro?",
      text: "Esta accion no se puede deshacer",
      icon: "warning",
      buttons: {
        cancel: true,
        confirm: true,
      },
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {

          if (this.voucherService.getVoucherByTankWithVehicle(this.currentTank.id).subscribe(
            (data) => {

              const voucherToCancel = data.vouchers.filter(voucher => voucher.id === id);
              voucherToCancel[0].status = "CANCELED";
              // Llamar a la función para editar el comprobante
              // console.log("voucher", data);
              this.voucherService.editVoucher(id, voucherToCancel[0]).subscribe(
                () => {
                  this.listVouchers();
                  console.log('Comprobante cancelado correctamente');
                },
                (error) => {
                  console.error('Error al cancelar el comprobante:', error);
                }
              );

            },
            (error) => {
              console.log('Error al obtener el comprobante:', error);
            }
          )) {
            return;
          }

          swal("Cupon cancelado", {
            icon: "success",
          });
        } else {
          swal("Accion cancelada");
          return;
        }
      });


    /*if (userConfirmed) {

    } else {
      // El usuario hizo clic en "Cancelar", puedes manejarlo si es necesario
      console.log('Acción cancelada');

    }*/
  }


  applyFilter(filter: any) {
    this.filter = filter;
    // console.log("filtros: ", filter);

    // Restaura la lista original antes de aplicar el filtro
    this.vouchers = [...this.originalVouchers];

    this.vouchers = this.vouchers.filter((voucher) => {
      // Inicialmente, todos los vouchers pasan la prueba
      let passed = true;

      if (this.filter.user && voucher.operator !== this.filter.user) {
        passed = false;
      }

      if (this.filter.status && this.filter.status !== voucher.status) {
        passed = false;
      }

      if (this.filter.dateFrom) {
        const voucherInitDate = new Date(voucher.initDate);
        if (voucherInitDate < this.filter.dateFrom) {
          passed = false;
        }
      }

      if (this.filter.dateTo) {
        const voucherDateTo = new Date(voucher.initDate);
        if (voucherDateTo > this.filter.dateTo) {
          passed = false;
        }
      }
      return passed;
    });

    // console.log("listado de vouchers: ", this.vouchers);
  }



}
